var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockClockwise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V8L10.5 9.5",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5H14V4",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.775 12.0002C10.9888 12.7421 10.0014 13.2359 8.93614 13.4198C7.87089 13.6037 6.77507 13.4697 5.78559 13.0344C4.79611 12.5991 3.95684 11.8818 3.37266 10.9723C2.78847 10.0627 2.48527 9.00116 2.50094 7.92028C2.51661 6.83939 2.85046 5.78708 3.46077 4.89484C4.07107 4.0026 4.93078 3.30999 5.93246 2.90356C6.93415 2.49712 8.03339 2.39487 9.09285 2.6096C10.1523 2.82432 11.125 3.34649 11.8894 4.11087C12.625 4.85587 13.2325 5.55837 14 6.50024",
    stroke: "#B3B3B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockClockwise);
export default __webpack_public_path__ + "static/media/ClockClockwise.64673a15ba43c829bd9f314b98c6054e.svg";
export { ForwardRef as ReactComponent };